import * as React from 'react'
import { Footer, AppShell, Content } from 'components'
import { NextPage } from 'next'
import { useTranslation } from 'i18n'
import { getStandaloneName } from 'utils/standalone'
import {
  Error404,
  Error500,
} from 'components/atomic/standalone/templates/Error'
import { captureException } from 'utils/sentry'

type InitialProps = {
  namespacesRequired: string[]
}

type Props = {
  statusCode: number | null
  standalone?: boolean
}

const Page: NextPage<Props, InitialProps> = ({
  statusCode,
  standalone = false,
}) => {
  const { t } = useTranslation('components')
  const messages = errorMessages[statusCode] || errorMessages.default

  if (standalone) return <StandaloneErrorPage statusCode={statusCode} />

  return (
    <AppShell.Base
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Content.Base style={{ flexGrow: 1, textAlign: 'center' }}>
        <h1 style={{ padding: '30px 0' }}>{t(messages.title)}</h1>
      </Content.Base>
      <Footer.Info />
    </AppShell.Base>
  )
}

Page.getInitialProps = async ({ req, res, err }) => {
  if (err && err.statusCode !== 404) {
    captureException(err)
  }

  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  const standalone = !!getStandaloneName(req)

  return {
    namespacesRequired: ['standalone.error', 'components', 'common'],
    statusCode,
    standalone,
  }
}

export default Page

const errorMessages = {
  404: {
    title: 'pageNotFound',
    description: 'mayWrongURLOrDeleted',
  },
  401: {
    title: 'doNotHaveAccess',
    description: 'thisAccountdoNotHaveAccess',
  },
  501: {
    title: 'errorOccures',
    description: 'plzRetryOrContact',
  },
  maintain: {
    title: 'underMaintenance',
    description: 'serviceCrrentAvailablePlzWait',
  },
  default: {
    title: 'errorOccured',
    description: 'plzRetryOrContact',
  },
}

type StandaloneErrorPageProps = {
  statusCode: number
}
const StandaloneErrorPage: React.FC<StandaloneErrorPageProps> = ({
  statusCode,
}) => {
  switch (statusCode) {
    case 404:
      return <Error404 />
    case 500:
      return <Error500 />
    default:
      return <Error500 />
  }
}
